import { isIE, supportMobxProxy } from '@jfs/ui-new/src/utils/utils'
import { configure } from 'mobx'
if (!supportMobxProxy() || isIE()) {
  configure({ useProxies: 'never' })
}
